import * as zod from 'zod';

export default zod.object({
  completedCount: zod.number().int().nonnegative(),
  currentActivity: zod.enum([
    'none',
    'approaching',
    'requestingPlan',
    'planning',
    'receivingPlan',
    'moving',
    'paused',
  ]),
  /**
   * The current linear distance moved from the starting pose (in meters).
   * Continuously updated during motion execution.
   */
  distanceMovedToNextWaypoint: zod.number().nonnegative().default(0),
  /**
   * Step ID of the motion substep (Waypoint or Arc) the arm is currently
   * moving toward, or null when the step is not actively executing waypoints.
   * Consumed by step-list display views to highlight the active waypoint.
   */
  currentWaypointID: zod.string().nullable().default(null),
});
